export default class Notifications {
    constructor(vm) {
        this.vm = vm;
    }

    get(event) {
        let trackingObject = null;

        switch (event) {
            case 'alert-banner-shown':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'Min Side Notifikation Top',
                    'eventAction': 'Shown',
                    'eventLabel': this.vm,
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
            case 'alert-banner-clicked':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'Min Side Notifikation Top',
                    'eventAction': 'Click',
                    'eventLabel': this.vm,
                    'eventValue': '0',
                    'eventNoninteraction': true
                };
                break;
        }
        return trackingObject;
    }
}
